var _rect, _circle, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor",
    fillOpacity: 0.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17,
    stroke: "currentColor",
    strokeOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_27_2267)",
    fillOpacity: 0.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "currentColor",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1152 23.5392C28.101 23.4791 28.0721 23.4235 28.0313 23.3772C27.9904 23.3309 27.9387 23.2954 27.8808 23.2739L25.1803 22.261L25.8675 18.8236C25.8831 18.7437 25.8722 18.661 25.8366 18.5878C25.801 18.5147 25.7426 18.4551 25.6702 18.418C25.5977 18.381 25.5152 18.3685 25.435 18.3825C25.3549 18.3964 25.2814 18.4361 25.2258 18.4955L19.9758 24.1205C19.9332 24.1654 19.9023 24.2202 19.886 24.28C19.8697 24.3397 19.8685 24.4026 19.8824 24.4629C19.8963 24.5233 19.925 24.5793 19.9658 24.6258C20.0067 24.6724 20.0584 24.7082 20.1164 24.7299L22.8178 25.7428L22.1325 29.1764C22.117 29.2563 22.1278 29.339 22.1634 29.4122C22.199 29.4854 22.2574 29.545 22.3299 29.582C22.4023 29.6191 22.4848 29.6315 22.565 29.6176C22.6452 29.6036 22.7186 29.5639 22.7742 29.5045L28.0242 23.8795C28.0661 23.8346 28.0963 23.7801 28.1121 23.7207C28.128 23.6614 28.129 23.5991 28.1152 23.5392ZM23.1267 28.0313L23.6175 25.576C23.6351 25.4889 23.6212 25.3984 23.5782 25.3206C23.5353 25.2428 23.4662 25.1828 23.3831 25.1513L20.9063 24.2208L24.8728 19.9711L24.3825 22.4264C24.365 22.5135 24.3789 22.604 24.4218 22.6818C24.4647 22.7595 24.5339 22.8195 24.6169 22.8511L27.0919 23.7792L23.1267 28.0313Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1182 21.0208C35.3794 20.9509 35.5353 20.6821 35.4547 20.424C34.6837 17.954 33.1344 15.7989 31.0387 14.2812C30.8198 14.1226 30.5153 14.1848 30.3658 14.41C30.2163 14.6352 30.2784 14.9381 30.4968 15.0974C32.3944 16.4822 33.8002 18.4378 34.5083 20.6777C34.5898 20.9354 34.8571 21.0908 35.1182 21.0208Z",
    fill: "url(#paint1_linear_27_2267)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8818 26.9792C12.6206 27.0491 12.4647 27.3179 12.5453 27.576C13.3163 30.046 14.8656 32.2011 16.9613 33.7189C17.1802 33.8774 17.4847 33.8152 17.6342 33.59C17.7837 33.3648 17.7216 33.0619 17.5032 32.9026C15.6056 31.5178 14.1998 29.5622 13.4917 27.3223C13.4102 27.0646 13.1429 26.9092 12.8818 26.9792Z",
    fill: "url(#paint2_linear_27_2267)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_2267",
    x1: 24,
    y1: 36,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20D5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20D5FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_2267",
    x1: 30.2691,
    y1: 14.5556,
    x2: 35.1081,
    y2: 21.0236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#404556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_2267",
    x1: 17.7309,
    y1: 33.4444,
    x2: 12.8919,
    y2: 26.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#404556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343849"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstIcon);
export default __webpack_public_path__ + "static/media/first-icon.be498d6e91bba289370a0dffe27c1d49.svg";
export { ForwardRef as ReactComponent };